module.exports = __webpack_public_path__ + "static/media/contact-image.f7515a63.webp";